<template>
  <div class="statistics-use-wrap">
    <div class="filter-wrap">
      <PBDRangeSelector />
    </div>
    <div class="row">
      <div class="cell">
        <ChartCard :title="$t('pbd_use_title_char_1')" chart-id="access" />
      </div>
      <div class="cell">
        <ChartCard :title="$t('pbd_use_title_char_2')" chart-id="registers" />
      </div>
    </div>
    <div class="full-cards-wrap">
      <ChartCard
        :title="$t('pbd_use_title_char_3')"
        chart-id="item-con"
        :searchable="true"
        type-filter="type"
        :paginate="true"
      />
      <ChartCard
        :title="$t('pbd_use_title_char_4')"
        chart-id="item-download"
        :searchable="true"
        type-filter="down-type"
        :paginate="true"
      />
      <ChartCard
        :title="$t('pbd_use_title_char_5')"
        :searchable="true"
        chart-id="words-search"
        type-filter="language"
        :paginate="true"
      />
    </div>
  </div>
</template>
  
<script>
import PBDRangeSelector from './PBDRangeSelector.vue'
import ChartCard from './ChartCard.vue'

export default {
  components: { PBDRangeSelector, ChartCard },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
.statistics-use-wrap
  display: flex
  flex-direction: column
  gap: vw(30px)

  .filter-wrap
    width: vw(350px)

    .mobile &
      width: 100%

.row
  display: flex
  margin-top: vw(10px)
  width: 100%
  gap: vw(30px)

  .mobile &
    display: flex
    flex-direction: column
    gap: vw(30px)

  .cell
    display: flex
    width: 49%

    .mobile &
      display: flex
      width: 100%

.full-cards-wrap
  display: flex
  flex-direction: column
  margin-top: vw(30px)
  gap: vw(30px)

  .mobile &
    margin-top: 0
</style>
